import { Controller } from "@hotwired/stimulus"
import { post } from '@rails/request.js'


export default class extends Controller {
    fetchCarrierServiceLevels(event) {
        var protocolIdentifier = event.target.getAttribute("data-protocol")
        post(`/shipping_label_templates/fetch_carrier_service_levels?carrier_id=${event.target.value}&protocol_id=${protocolIdentifier}`, { responseKind: 'turbo-stream' })
    }
}